module.exports = __webpack_public_path__ + "static/media/Musica e Sociedade_main photo.ab613a5c.jpg";